import { FilterCollect } from './FilterCollect';
import { FilterResult } from './FilterResult';
export class FilterEngine {
    constructor(engine, query) {
        this._engine = engine;
        this._query = query;
    }
    get engine() {
        return this._engine;
    }
    get query() {
        return this._query;
    }
    execute() {
        const result = new FilterResult(this.query);
        const collector = new FilterCollect(this.query, result);
        this.engine.dataset.data.forEach((row, index) => {
            collector.collect(row, index);
        });
        return result;
    }
}
